import { conciergeRequestFromSearch } from './lib/concierge-link';
import { useConfig } from './lib/ConfigContext';
import { ConciergePage } from './pages/ConciergePage';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { useAuth } from './auth/AuthContext';
import { Layout } from './components/Layout';
import { LoginPage } from './pages/LoginPage';
import { CallbackPage } from './pages/CallbackPage';
import { HomesPage } from './pages/HomesPage';
import { CreateHomePage } from './pages/CreateHomePage';
import { HomeDetailPage } from './pages/HomeDetailPage';
import { EdgesPage } from './pages/EdgesPage';
import { EdgeDetailPage } from './pages/EdgeDetailPage';
import { RegistrationsPage } from './pages/RegistrationsPage';

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated } = useAuth();
  const location = useLocation();
  const request = location.pathname === '/concierge' ? conciergeRequestFromSearch(location.search) : null;
  if (!isAuthenticated) return <Navigate to={request ? `/login?request=${request}` : '/login'} replace />;
  return <Layout>{children}</Layout>;
}

export default function App() {
  const config = useConfig();
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/auth/callback" element={<CallbackPage />} />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            {config.conciergeOnly ? <Navigate to="/concierge" replace /> : <HomesPage />}
          </ProtectedRoute>
        }
      />
      <Route
        path="/homes/new"
        element={
          <ProtectedRoute>
            <CreateHomePage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/homes/:homeId"
        element={
          <ProtectedRoute>
            <HomeDetailPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/edges"
        element={
          <ProtectedRoute>
            <EdgesPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/edges/:edgeId"
        element={
          <ProtectedRoute>
            <EdgeDetailPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/registrations"
        element={
          <ProtectedRoute>
            <RegistrationsPage />
          </ProtectedRoute>
        }
      />
      <Route path="/concierge" element={<ProtectedRoute><ConciergePage /></ProtectedRoute>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
